import { render } from "./Edit.vue?vue&type=template&id=0e44cfb7&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=0e44cfb7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e44cfb7"

export default script